module.exports = __webpack_public_path__ + "static/media/ribbon.428c597a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ribbon.svg
// module id = 183
// module chunks = 0